import { render, staticRenderFns } from "./ShippingAddressForm.vue?vue&type=template&id=474bc305&"
import script from "./ShippingAddressForm.vue?vue&type=script&lang=js&"
export * from "./ShippingAddressForm.vue?vue&type=script&lang=js&"
import style0 from "./ShippingAddressForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports